import { mapGetters, mapActions } from 'vuex'
import CompanyModule, { MODULE_NAME } from './index'

const CompanyMixin = {
  namespaced: CompanyModule.namespaced,
  computed: { ...mapGetters(MODULE_NAME, Object.keys(CompanyModule.getters)) },
  methods: { ...mapActions(MODULE_NAME, Object.keys(CompanyModule.actions)) }
}

export default CompanyMixin



// WEBPACK FOOTER //
// ./src/store/module/company/mixin.js